export const CREATE_MATCHES_START='CREATE_MATCHES_START';
export const CREATE_MATCHES_SUCCESS='CREATE_MATCHES_SUCCESS';
export const CREATE_MATCHES_FAIL='CREATE_MATCHES_FAIL';

export const SET_SELECTED_MATCHES='SET_SELECTED_MATCHES';

